import { Table, Pagination} from 'react-bootstrap';
import { Loader } from '../../../utils/tools';
import Moment from 'react-moment';


const ItemsPagination = ({
    items,
    goToPrevPage,
    goToNextPage,
    goToEdit,
    goToImageupload,
    goToNewsView
}) => {


    return(
        <>
     
            { items && items.shops ?
                <>

             
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                               <th>Item ID </th>
                                <th>Name</th>
                                <th>Shop ID</th>
                                <th>Created</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                        
                   

                            { items.shops.map(item=>(
                                <tr key={item.onlineId}>
                                       <td>{item.onlineId}</td>
                                    <td>{item.brandName}</td>
                                    <td>{item.shopId}</td>
                                   
                                    <td><Moment to={item.createdDate}></Moment></td>
                                    <td>{item.finalStatus}</td>
                                    
                                    <td className='action_btn status_btn'
                                        onClick={()=>goToNewsView(item.onlineId)}
                                    >
                                        View
                                    </td>
                                   
                                    <td className='action_btn edit_btn'
                                       onClick={()=> goToEdit(item.onlineId)}
                                    >
                                        Edit
                                    </td>
                                    

                                    <td className='action_btn remove_btn'
                                        onClick={()=>goToImageupload(item.onlineId)}
                                    >
                                        Image
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Pagination>

                        { ((items.totalPages-items.currentPage )!==items.totalPages)?
                            <>

                             <Pagination.Prev 
                                    onClick={()=> goToPrevPage((items.currentPage-1))}
                                />
                                <Pagination.Item
                                    onClick={()=> goToPrevPage((items.currentPage-1))}
                                >
                                    {items.currentPage-1}
                                </Pagination.Item>
                                
                                
                            </>
                            :null
                        }
                        <Pagination.Item active>{items.currentPage}</Pagination.Item>


                        { ((items.totalPages-(items.currentPage+1))!==0) ?
                            <>
                                <Pagination.Item
                                onClick={()=> goToNextPage(items.currentPage+1)}
                                >
                                    {(items.currentPage+1)}
                                </Pagination.Item>
                                <Pagination.Next onClick={()=> goToNextPage(items.currentPage+1)}/>

                                
                            </>
                        :null
                        }

                    </Pagination>
                </>
            :
                <Loader/>
            }


        </>
    )

}

export default ItemsPagination;